import React, { useState } from 'react';
import Button from '../Button/Button';
import {
  HeaderWrap,
  HeaderInner,
  Brand,
  NavLinks,
  NavLink,
  Caret,
  Actions,
  TextLink,
  LogoMark
  , MobileBar, MobileMenuButton, MobileBrand, MobileActions, MobileMenu
} from './Header.styles';
import MegaMenu1 from './MegaMenu/Menu1/Menu1';
import MegaMenu2 from './MegaMenu/Menu2/Menu2';

const navItems = [
  { label: 'Placeholder 1', caret: true },
  { label: 'Placeholder 2', caret: true },
  { label: 'Placeholder 3', caret: true },
  { label: 'Placeholder 4', caret: true },
  { label: 'Placeholder 5', caret: false }
];

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const loginUrl = process.env.REACT_APP_SCOPELOGINURL || '#';
  console.log("loginUrl", loginUrl);
  return (
    <>
    <HeaderWrap>
      {/* Mobile bar: menu, centered brand, actions */}
      <MobileBar>
        <MobileMenuButton
          aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={mobileOpen}
          aria-controls="mobile-menu"
          onClick={() => setMobileOpen(prev => !prev)}
        >
          {/* simple menu / close icon */}
          {mobileOpen ? (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 6L18 18M6 18L18 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
          ) : (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 7h18M3 12h18M3 17h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
          )}
        </MobileMenuButton>

        <MobileBrand href="#" aria-label="SCOPE Console">
          SCOPE
        </MobileBrand>

        <MobileActions>
          <TextLink href={loginUrl} target="_blank" rel="noopener noreferrer">Log in</TextLink>
        </MobileActions>
      </MobileBar>

      <HeaderInner>
        <Brand href="#" aria-label="SCOPE Console">
          SCOPE CONSOLE
        </Brand>

        <NavLinks aria-label="Primary">
          {navItems.map((item, idx) => (
            <NavLink
              key={item.label}
              href="#"
              className={openMenuIndex === idx ? 'open' : ''}
              onMouseEnter={() => setOpenMenuIndex(idx)}
              onMouseLeave={() => setOpenMenuIndex(null)}
            >
              {item.label}
              {item.caret && <Caret aria-hidden="true" />}

              {idx === 0 && (
                <div style={{ position: 'absolute', top: '100%', left: 0, display: openMenuIndex === 0 ? 'block' : 'none' }}>
                  <MegaMenu1 />
                </div>
              )}
              {idx === 1 && (
                <div style={{ position: 'absolute', top: '100%', left: 0, display: openMenuIndex === 1 ? 'block' : 'none' }}>
                  <MegaMenu2 />
                </div>
              )}
            </NavLink>
          ))}
        </NavLinks>
        <Actions>
          <TextLink href={loginUrl} target="_blank" rel="noopener noreferrer">Log in</TextLink>
          <Button variant="primary" size="small">Get started</Button>
        </Actions>
      </HeaderInner>

    </HeaderWrap>
    {/* Mobile menu slide-over placed outside HeaderWrap so it covers full viewport */}
    {mobileOpen && (
      <MobileMenu id="mobile-menu" role="dialog" aria-modal="true">
        <button
          className="mobile-close"
          aria-label="Close menu"
          onClick={() => setMobileOpen(false)}
        >
          {/* close icon */}
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 6L18 18M6 18L18 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </button>

        <nav aria-label="Mobile primary">
          {navItems.map(item => (
            <a
              key={item.label}
              href="#"
              onClick={() => setMobileOpen(false)}
            >
              {item.label}
            </a>
          ))}
        </nav>
      </MobileMenu>
    )}
    </>
  );
};

export default Header;
